import { AC_STEP_CONFIRM_AGE, AC_STEP_USER_INFO } from "../../utils/AccountCreationConstants";

import useAccountCreationData from "../../../../../../state/landingPages/accountCreation/UseAccountCreationData";

const useAccountCreationSelfWarning = () => {
  const { updateAccountCreationStep } = useAccountCreationData();

  const onContinueClicked = () => {
    updateAccountCreationStep(AC_STEP_USER_INFO);
  };

  const onBackClicked = () => {
    updateAccountCreationStep(AC_STEP_CONFIRM_AGE);
  };

  return {
    onContinueClicked,
    onBackClicked
  };
};

export default useAccountCreationSelfWarning;